(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mm-color-gallery')) {
    customElements.define('mm-color-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.addEventListener('click', (event) => {
          const preview = event.target.closest('.mm-color-preview');
          if (!preview) return;
          const input = Array.from(this.closest('.shopify-section').querySelectorAll('variant-picker input')).find(input => input.value === preview.dataset.color);
          if (!input) return;
          event.preventDefault();
          this.showColor(preview.dataset.color);
          input.click();
        }, { signal });
        this.closest('.shopify-section').addEventListener('change', (event) => {
          if (event.target.matches('variant-picker input')) this.showColor(event.target.value);
        }, { signal });
      }
      disconnectedCallback() { this.controller.abort(); }
      showColor(color) {
        const previews = Array.from(this.querySelectorAll('.mm-color-preview'));
        const preview = previews.find(item => item.dataset.color === color);
        if (!preview) return;
        for (const side of ['front', 'back']) {
          const link = this.querySelector('[data-main="' + side + '"]');
          const image = link.querySelector('img');
          image.removeAttribute('srcset');
          image.src = preview.dataset[side];
          link.href = preview.dataset[side].replace('width=1600', 'width=2400');
        }
        for (const item of previews) {
          if (item === preview) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
